<template>
  <div class="separation-anxiety-mission-possible-card">
    <va-card title="Do-It-Yourself: Mission Possible">
      <div class="mission-possible">
        <div class="image-container">
          <img src="../../assets/gracie-relax.jpg" alt="Pyrenees mix relaxing on the floor" />
        </div>
        <div class="content-container">
          <p>
            This online, self paced course, Mission POSSIBLE is the perfect place to start your separation anxiety journey if you are a do it yourself-er (DIY) or on a budget.
            Moderated by CSATs, you'll learn the ins and outs of SA better preparing you for one on one training or tackling it all by yourself.
          </p>
          <p>
            This course covers:
            <ul>
              <li>Useful technology</li>
              <li>Separation anxiety terminology</li>
              <li>Food toys</li>
              <li>Thresholds</li>
              <li>Crating</li>
              <li>Homeopathic/medicinal treatments</li>
              <li>Missions</li>
              <li>Data tracking</li>
              <li>Pre-departure ques (PDQs)</li>
              <li>Adjusting criteria</li>
              <li>Regressions</li>
              <li>Support</li>
              <li>And more!</li>
            </ul>
          </p>
          <a href="https://malenademartini.com/for-owners/separation-anxiety-in-dogs-mission-possible-online-course/?aff=121"
            alt="Mission Possible Online Course"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            :style="{color: this.$themes.primary}" >
            <va-button>Learn More</va-button>
          </a>
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>

export default {
  name: 'separation-anxiety-mission-possible-card',
}
</script>

<style scoped lang="scss">
.separation-anxiety-mission-possible-card {
  .mission-possible {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include media-breakpoint-up(lg) {
      display: flex;
      flex-direction: row-reverse;
    }

    .image-container {
      width: 90%;
      overflow: hidden;

      @include media-breakpoint-up(lg) {
        height: 120%;
        width: auto;
        margin-top: 2rem;
      }

      img {
        width: 100%;
        height: auto;
        border-radius: 0.375rem;
      }
    }

    p {
      margin-top: 1rem;
    }

    ul {
      margin-top: 1.6rem;
      margin-left: 2rem;

      li {
        list-style: circle;

        .italic {
          margin-top: 0;
          font-style: italic;
        }
      }
    }

    .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 1rem;
    }

    .content-container {
      @include media-breakpoint-up(lg) {
        margin-right: 2rem;
      }
    }
  }
}
</style>
